module.exports = __webpack_public_path__ + "img/paysafecard.17a69895.svg";